import React from 'react';

const Table = ({
  columns = [],
  data = [],
  onRowClick,
  emptyMessage = 'No data available',
  className = '',
  loading = false,
  getRowClassName,
}) => {
  const renderActionIcon = (action, row) => {
    const iconSVG = {
      edit: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
      ),
      delete: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="3 6 5 6 21 6"/>
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
          <line x1="10" y1="11" x2="10" y2="17"/>
          <line x1="14" y1="11" x2="14" y2="17"/>
        </svg>
      ),
      view: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
          <circle cx="12" cy="12" r="3"/>
        </svg>
      ),
      history: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <polyline points="12 6 12 12 16 14"/>
        </svg>
      ),
    };

    const icon = iconSVG[action.type.toLowerCase()] || <span>•</span>;

    const getButtonClasses = (type) => {
      const baseClasses = "p-1 hover:scale-110 transition-all duration-200 flex items-center";
      switch (type.toLowerCase()) {
        case 'delete':
          // return `${baseClasses} text-danger-600 hover:text-danger-800`;
        case 'history':
        case 'edit':
        default:
          return `${baseClasses} text-primary-600 hover:text-primary-800`;
      }
    };

    return (
      <button
        key={action.type}
        onClick={(e) => {
          e.stopPropagation();
          action.onClick(row);
        }}
        className={getButtonClasses(action.type)}
        title={action.type.charAt(0).toUpperCase() + action.type.slice(1)}
      >
        {icon}
      </button>
    );
  };

  return (
    <div className={`overflow-auto flex-1 min-h-0 rounded-lg ccustom-sidebar-scrollbar ${className}`}>
  <table className="min-w-full divide-y divide-gray-200">
    <thead className="bg-primary-200 sticky top-0 z-10 w-full">
    {/* <div className={`overflow-auto flex-1 min-h-0 ${className}`}>
      <table className="min-w-full divide-y divide-gray-200 rounded-lg">
        <thead className="bg-primary-200 sticky top-0 z-10 w-full"> */}
          <tr>
            {columns.map((column, index) => (
              <th
                key={index}
                className={`px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wider whitespace-nowrap ${
                  column.align === 'center' ? 'text-center' : column.align === 'right' ? 'text-right' : 'text-left'
                } ${column.sortable ? 'cursor-pointer select-none hover:bg-primary-300' : ''} ${
                  column.sticky === 'left' ? 'sticky left-0 z-20 bg-primary-200' :
                  column.sticky === 'right' ? 'sticky right-0 z-20 bg-primary-200' :
                  column.sticky ? 'sticky left-0 z-20 bg-primary-200' : ''
                }`}
                style={{ width: column.width }}
                onClick={column.sortable ? column.onSort : undefined}
              >
                <div className={`flex items-center gap-2 ${
                  column.sortable
                    ? 'justify-between'
                    : column.align === 'center'
                      ? 'justify-center'
                      : column.align === 'right'
                        ? 'justify-end'
                        : 'justify-start'
                }`}>
                  <span>{column.header}</span>
                  {column.sortable && (
                    <span className="flex flex-col">
                      {column.sortActive && column.sortDirection === 'asc' ? (
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M5 10l5-5 5 5H5z"/>
                        </svg>
                      ) : column.sortActive && column.sortDirection === 'desc' ? (
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M15 10l-5 5-5-5h10z"/>
                        </svg>
                      ) : (
                        <svg className="w-4 h-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M5 8l5-5 5 5H5zM5 12l5 5 5-5H5z"/>
                        </svg>
                      )}
                    </span>
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
            {loading ? (
              // Loading skeleton
              [...Array(5)].map((_, rowIndex) => (
                <tr key={`skeleton-${rowIndex}`} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-primary-50'}>
                  {columns.map((_, colIndex) => (
                    <td key={`skeleton-col-${colIndex}`} className="px-4 py-1">
                      <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                    </td>
                  ))}
                </tr>
              ))
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="px-4 py-8 text-center text-gray-500 bg-white">
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              data.map((row, rowIndex) => {
                const baseRowClass = `${onRowClick ? 'cursor-pointer hover:bg-gray-50' : ''} transition-colors ${rowIndex % 2 === 0 ? 'bg-white' : 'bg-primary-50'}`;
                const additionalRowClass = getRowClassName ? getRowClassName(row, rowIndex) : '';
                const rowClassName = `${baseRowClass} ${additionalRowClass}`.trim();

                return (
                  <tr
                    key={rowIndex}
                    className={rowClassName}
                    onClick={() => onRowClick && onRowClick(row)}
                  >
                  {columns.map((column, colIndex) => (
                    <td
                      key={colIndex}
                      className={`px-4 py-1 text-sm text-gray-900 whitespace-nowrap ${
                        column.align === 'center' ? 'text-center' : column.align === 'right' ? 'text-right' : 'text-left'
                      } ${
                        column.sticky === 'left' ? `sticky left-0 z-[5] ${rowIndex % 2 === 0 ? 'bg-white' : 'bg-primary-50'}` :
                        column.sticky === 'right' ? `sticky right-0 z-[5] ${rowIndex % 2 === 0 ? 'bg-white' : 'bg-primary-50'}` :
                        column.sticky ? `sticky left-0 z-[5] ${rowIndex % 2 === 0 ? 'bg-white' : 'bg-primary-50'}` : ''
                      }`}
                    >
                      {column.actions ? (
                        <div className="flex gap-3 justify-center">
                          {column.actions.map((action) => renderActionIcon(action, row))}
                        </div>
                      ) : column.render ? (
                        column.render(row[column.accessor], row, rowIndex)
                      ) : (
                        row[column.accessor]
                      )}
                    </td>
                  ))}
                </tr>
              )
              })
            )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
